<template>
  <div class="custom-select" :tabindex="tabindex" @blur="closeSelect">
    <div
      class="selected"
      :class="{ open: open }"
      @click.stop="toogleView"
      v-if="!disabled"
    >
      {{ selected }}
    </div>
    <div class="selected disabled" v-else-if="disabled">
      {{ selected }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div class="search">
        <input type="text" v-model="search" ref="search" @blur="closeSelect" />
      </div>
      <div
        class="item"
        v-for="(option, i) of searchData"
        :key="i"
        @click="choiceOption(option)"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      search: '',
      selected: this.default
        ? this.default
        : this.options.length > 0
        ? this.options[0]
        : null,
      open: false,
    };
  },
  computed: {
    searchData: function () {
      const search = this.search.toLowerCase();
      if (search) {
        return this.options.filter((option) =>
          option.toLowerCase().includes(search),
        );
      }
      return this.options;
    },
  },
  methods: {
    choiceOption(option) {
      this.selected = option;
      this.open = false;
      this.$emit('click', option);
    },
    toogleView() {
      this.search = '';
      this.open = !this.open;
    },
    closeSelect(e) {
      this.open = e.relatedTarget
        ? e.relatedTarget.contains(this.$refs.search)
        : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 28px;
  line-height: 35px;

  .selected {
    min-width: 200px;
    background-color: transparent;
    border-radius: 4px;
    color: #fff;
    cursor: inherit;
    text-decoration: none;
    user-select: none;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    overflow: hidden;

    &.open {
      box-sizing: border-box;
      padding-left: 1rem;
      padding-top: 12px;
      position: relative;
      border-right: 2px solid #979799;
      border-left: 2px solid #979799;
      border-top: 2px solid #979799;
      border-radius: 4px 4px 0px 0px;
      max-width: 500px;
      width: 100%;
      background-color: #212227;
      z-index: 1;

      &:after {
        display: inline-block;
        content: '';
        width: 20px;
        height: 20px;
        transform: translateY(25%) rotate(180deg);
        background: url('../../assets/eva_arrow-ios-back-outline.png') no-repeat
          center;
      }
    }

    &:after {
      display: inline-block;
      content: '';
      width: 20px;
      height: 20px;
      transform: translateY(23%);
      background: url('../../assets/eva_arrow-ios-back-outline.png') no-repeat
        center;
    }
  }

  .items {
    box-sizing: border-box;
    color: #fff;
    border-radius: 0px 0px 4px 4px;
    overflow: hidden;
    border-right: 2px solid #979799;
    border-left: 2px solid #979799;
    border-bottom: 2px solid #979799;
    position: relative;
    background-color: #212227;
    left: 0;
    right: 0;
    z-index: 1;
    max-height: 450px;
    max-width: 500px;
    width: 100%;
    overflow: auto;
    font-size: 24px;
    font-family: 'Roboto', sans-serif;
    font-style: normal;

    .search {
      position: sticky;
      left: 16px;
      top: 0;
      box-sizing: border-box;
      width: calc(100% - 16px);
      margin: 0;
      padding: 0;
      height: 32px;
      padding-top: 0.5rem;
      padding-bottom: 3.5rem;
      background-color: #212227;

      input[type='text'] {
        width: calc(100% - 16px);
        font-size: 24px;
        height: 32px;
        background-color: #212227;
        border: 2px solid #979799;
        border-radius: 4px;
        color: #fff;
      }

      &:before {
        position: absolute;
        display: block;
        content: '';
        width: 18px;
        height: 18px;
        right: 16px;
        top: 18px;
        z-index: 2;
        background: url('../../assets/search.svg') no-repeat center;
      }
    }

    .item {
      color: #fff;
      padding-left: 16px;
      cursor: pointer;
      user-select: none;
      padding: 0.25rem 1rem;

      &:hover {
        background-color: #171820;
      }
    }
  }

  .disabled {
    color: #bbb;

    &:after {
      display: none;
    }
  }

  .selectHide {
    display: none;
  }
}
</style>
